export const CONSTANTS = {
  primary: "#005DF6",
  secondarydark: "#1E3037",
  yellow: '#FEC76E',
  green: '#51CCA3',
  red: '#FF607D',
  darkblue: "#3d6a88",
  lightgrey: "#F1F8FC",
  darkergrey: "#5e7386",
  bordergrey: "#e0f1fb",
  background: "#FCFEFF",
  body: '18px',
  h4: '21px',
  h3: '28px',
  h2: '38px',
  h1: '50px',
  display2: '61px',
  display1: '90px',

}



// WEBPACK FOOTER //
// ./src/static/constants.js